import React, { useEffect, useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
  FlatList,
  ScrollView
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import Calendar from "react-calendar";
import moment from "moment";
import { FontAwesome5 } from "@expo/vector-icons";
import { pickImage } from "../../action/authImage";
import { apiservice, BaseUrlimage } from "../../service/service";
import { useRecoilState } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
const { width, height } = Dimensions.get("window");
import "react-calendar/dist/Calendar.css";

export default function editbanner({ navigation, route }) {
  const [token, setToken] = useRecoilState(tokenState);
  const [locate, setLo] = useState({});
  const [handelCalendar, setHandelCalendar] = useState(false);
  const [dateState, setDateState] = useState(new Date());
  const [day, setday] = useState(null);
  const changeDate = (e) => {
    setDateState(e);
  };
  const [locate1, setLo1] = useState({});
  const [list, setList] = useState([]);
  const [handelCalendar1, setHandelCalendar1] = useState(false);
  const [dateState1, setDateState1] = useState(new Date());
  const changeDate1 = (e) => {
    setDateState1(e);
  };
  const [body, setbody] = useState({
    Type: "",
    page: route.params.page,
    FixorRandom: "",
    startDate: moment(),
    expireDate: moment(),
    img_list: [],
    img: [],
    status: true,
  });

  useEffect(() => {
    if (route?.params?.body?.id) {
      setbody({
        ...route?.params?.body,
        img: route?.params?.body?.img || [],
        img_list:
          route?.params?.body?.img_list2 || route?.params?.body?.img_list,
      });
    }
    callAPI();
  }, []);

  const callAPI = async () => {
    const res = await apiservice({
      path: "/banner/getallview_banner",
      token: token?.accessToken,
    });
    setList(res.data.data);
  };

  return (
    <View style={styles.container}>
      <Dawer navigation={navigation} />
      <View style={styles.back}>
        <Admin />
        <View style={styles.viewfree}>
          <Text style={styles.textfree}>
            BANNER{" "}
            <Text style={styles.textfree1}>
              / <Text style={styles.textfree1}>EDIT</Text>
            </Text>
          </Text>
        </View>
        <View style={styles.viewfree}>
          <View style={styles.viewbanner}>
            <View
              style={{
                width: width * 0.26,
                padding: 10,
              }}
            >
              <Image
                source={
                  body.img
                    ? { uri: BaseUrlimage + body.img_list?.[0] }
                    : require("../../image/3333.png")
                }
                style={styles.img}
              />
              <Text style={styles.texthead}>
                {route.params.page == "pagedaily"
                  ? "หน้า DAILY BONUS"
                  : route.params.page == "pageevent"
                    ? "หน้า EVENT"
                    : "หน้า START RUN"}
              </Text>
              <Text style={styles.textfic}>
                {route.params.page == "pagedaily"
                  ? "ขนาด 1000 * 450"
                  : route.params.page == "pageevent"
                    ? "ขนาด 1200 * 600"
                    : "ขนาด 1200 * 600"}
              </Text>
            </View>
            <View
              style={{
                width: width * 0.18,
                paddingHorizontal: 10,
              }}
            >
              <Text style={styles.texthead}>เลือกรูปแบบการแสดงผล</Text>
              <View style={{ flexDirection: "row", marginTop: 20 }}>
                {body.Type == "FIX" ? (
                  <TouchableOpacity
                    onPress={() => {
                      setbody({ ...body, Type: "SLIDE" });
                    }}
                    style={[styles.shod, { backgroundColor: "#FCC81D" }]}
                  />
                ) : (
                  <TouchableOpacity
                    onPress={() => {
                      setbody({ ...body, Type: "FIX" });
                    }}
                    style={[styles.shod, { backgroundColor: "#fff" }]}
                  />
                )}
                <Text style={[styles.texthead, { alignSelf: "center" }]}>
                  ภาพนิ่ง
                </Text>
              </View>
              <View style={{ flexDirection: "row", marginTop: 20 }}>
                {body.Type != "FIX" ? (
                  <TouchableOpacity
                    onPress={() => {
                      setbody({ ...body, Type: "FIX" });
                    }}
                    style={[styles.shod, { backgroundColor: "#FCC81D" }]}
                  />
                ) : (
                  <TouchableOpacity
                    onPress={() => {
                      setbody({ ...body, Type: "SLIDE" });
                    }}
                    style={[styles.shod, { backgroundColor: "#fff" }]}
                  />
                )}
                <Text style={[styles.texthead, { alignSelf: "center" }]}>
                  ภาพสไลค์
                </Text>
              </View>
              <TouchableOpacity
                onPress={async () => {
                  const response = await apiservice({
                    path: body.id ? "/banner/updatebanner" : "/banner/create",
                    method: body.id ? "put" : "post",
                    body: { ...body, page: route?.params?.page },
                    token: token?.accessToken,
                  });

                  if (response.status == 200) {
                    navigation.goBack();
                  }
                }}
                style={styles.touchedit}
              >
                <Text style={[styles.texthead1, { alignSelf: "center" }]}>
                  UPDATE
                </Text>
              </TouchableOpacity>
            </View>
          </View>

          {
            <View
              style={{
                width: width * 0.32,
                height: height * 0.35,
                backgroundColor: "#fff",
                padding: 10,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: 20,
                }}
              >
                <View style={{ flexDirection: "row" }}>
                  {body.FixorRandom == "Random" ? (
                    <TouchableOpacity
                      onPress={() => {
                        setbody({ ...body, FixorRandom: "Fix" });
                      }}
                      style={[styles.shod, { backgroundColor: "#FCC81D" }]}
                    />
                  ) : (
                    <TouchableOpacity
                      onPress={() => {
                        setbody({ ...body, FixorRandom: "Random" });
                      }}
                      style={[styles.shod, { backgroundColor: "#fff" }]}
                    />
                  )}
                  <Text style={[styles.texthead]}>RANDOM</Text>
                </View>
                <View>
                  <FlatList
                    numColumns={3}
                    data={body?.img_list}
                    scrollEnabled={false}
                    renderItem={({ index, item }) => {
                      return (
                        <TouchableOpacity
                          onPress={() => {
                            if (
                              body?.img?.filter((e) => e == index)?.length == 0
                            ) {
                              setbody((val) => ({
                                ...val,
                                img: val?.img?.concat(index),
                              }));
                            } else {
                              setbody((val) => ({
                                ...val,
                                img: body?.img?.filter((e) => e != index),
                              }));
                            }
                          }}
                          disabled={body?.Type != "FIX"}
                        >
                          <TouchableOpacity
                            onPress={() => {
                              setbody((val) => ({
                                ...val,
                                img_list: body?.img_list?.filter(
                                  (e, i) => i != index
                                ),
                              }));
                            }}
                            style={[styles.botton2, { alignSelf: "flex-end" }]}
                          >
                            <FontAwesome5
                              name="window-close"
                              size={18}
                              color="#AFAFAF"
                            />
                          </TouchableOpacity>
                          {item.length == 0 ? (
                            <View style={{ width: width * 0.2, height: 100 }} />
                          ) : (
                            <Image
                              source={{
                                uri: item,
                              }}
                              style={[
                                styles.imgfixflat,
                                {
                                  borderWidth:
                                    body?.img?.filter((e) => e == index)
                                      ?.length == 0
                                      ? 0
                                      : 2,
                                  borderColor:
                                    body?.img?.filter((e) => e == index)
                                      ?.length == 0
                                      ? "transparent"
                                      : "#FCC81D",
                                },
                              ]}
                            />
                          )}
                        </TouchableOpacity>
                      );
                    }}
                  />
                  <View style={{ flexDirection: "row", marginTop: 20 }}>
                    <TouchableOpacity
                      onPress={async () => {
                        const response = await pickImage();
                        console.log("====================================");
                        console.log(response);
                        console.log("====================================");
                        let arr = body.img_list || [];
                        let setArr = arr.concat(response);
                        setbody({ ...body, img_list: setArr });
                      }}
                      style={[styles.tochup, { backgroundColor: "#FCC81D" }]}
                    >
                      <Text style={styles.textup}>Upload</Text>
                    </TouchableOpacity>
                    <TouchableOpacity
                      onPress={async () => {
                        const response = await apiservice({
                          path: "/image/delete/" + body.img_list,
                          method: "delete",
                        });

                        setbody({ ...body, img_list: [] });
                      }}
                      style={[styles.tochup, { marginLeft: 20 }]}
                    >
                      <Text style={styles.textup}>Reset</Text>
                    </TouchableOpacity>
                  </View>
                  <Text style={styles.textRe}>
                    Allowed JPG, GIF or PNG. Max size of 800kB
                  </Text>
                </View>
              </View>
              <View style={styles.viewtouch}></View>
            </View>
          }
        </View>
        <ScrollView style={{ maxHeight: height * 0.4, marginTop: 20 }}>
          <FlatList
            data={list?.filter((e) => e?.type == route?.params?.page)}
            scrollEnabled={false}
            renderItem={({ item, index }) => {
              return (
                <View>
                  <View
                    style={{
                      flexDirection: "row",
                      marginTop: 20,
                      justifyContent: "space-between",
                    }}
                  >
                    <Text style={styles.textto}>{index + 1}</Text>
                    <Image
                      style={{ width: width * 0.1, height: width * 0.05 }}
                      source={{ uri: BaseUrlimage + item?.img_name }}
                    />
                    <View style={{ flexDirection: "row" }}>
                      <TextInput
                        style={{
                          width: width * 0.1,
                          height: 30,
                          backgroundColor: "#fff",
                          borderWidth: 1,
                          borderColor: "#D9D9D9",
                          paddingLeft: 10,
                          borderRadius: 5,
                          color: "#777777",
                          fontFamily: "Prompt-Regular",
                          alignSelf: "center",
                        }}
                        type={true}
                        Locate={locate}
                        setLo={setLo}
                        setHandelCalendar={setHandelCalendar}
                        value={moment(item.start).format("DD/MM/YYYY")}
                        editable={false}
                      />
                      <TouchableOpacity
                        onPress={() => {
                          setday(item?.id);
                          setHandelCalendar((val) => !val);
                        }}
                        style={styles.botton2}
                      >
                        <FontAwesome5
                          name="calendar-alt"
                          size={18}
                          color="#AFAFAF"
                        />
                      </TouchableOpacity>
                    </View>
                    <Text style={styles.textto}>ถึง</Text>
                    <View style={{ flexDirection: "row" }}>
                      <TextInput
                        style={{
                          width: width * 0.1,
                          height: 30,
                          backgroundColor: "#fff",
                          borderWidth: 1,
                          borderColor: "#D9D9D9",
                          paddingLeft: 10,
                          borderRadius: 5,
                          color: "#777777",
                          fontFamily: "Prompt-Regular",
                          alignSelf: "center",
                        }}
                        type={true}
                        Locate={locate1}
                        setLo={setLo1}
                        setHandelCalendar={setHandelCalendar1}
                        value={moment(item.exp).format("DD/MM/YYYY")}
                        onChangeText={(text) => {
                          setbody({ ...body, expireDate: text });
                        }}
                      />
                      <TouchableOpacity
                        onPress={() => {
                          setday(item?.id);
                          setHandelCalendar1((val) => !val);
                        }}
                        style={styles.botton2}
                      >
                        <FontAwesome5
                          name="calendar-alt"
                          size={18}
                          rr
                          color="#AFAFAF"
                        />
                      </TouchableOpacity>
                    </View>
                    <Text style={styles.textto}>{item?.viwe}</Text>
                    <TouchableOpacity
                      onPress={async () => {
                        const response = await apiservice({
                          path: "/banner/deleteview_banner?id=" + item.id,
                          method: "delete",
                          token: token?.accessToken,
                        });
                        callAPI();
                      }}
                      style={styles.botton2}
                    >
                      <Text style={styles.textto}>DELETE</Text>
                    </TouchableOpacity>
                  </View>
                </View>
              );
            }}
            ListHeaderComponent={
              <View
                style={{
                  flexDirection: "row",
                  backgroundColor: "#A1A1A1",
                  height: 45,
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Text style={styles.textto}>No</Text>
                <Text style={styles.textto}>Image</Text>
                <Text style={styles.textto}>Start Date</Text>
                <Text style={styles.textto}> </Text>
                <Text style={styles.textto}>End Date</Text>
                <Text style={styles.textto}>Count</Text>
                <Text style={styles.textto}> </Text>
              </View>
            }
          />
        </ScrollView>
      </View>
      {handelCalendar && (
        <View
          style={{
            width: width * 0.15,
            position: "absolute",
            zIndex: 99,
            top: 415,
            left: 200,
          }}
        >
          <Text
            style={{
              fontSize: 10,
              color: "#000",
              textAlign: "center",
              fontFamily: "Prompt-Regular",
            }}
          >
            <Calendar
              value={dateState}
              onChange={changeDate}
              onChangeText={(text) => {
                setbody({ ...body, startDate: text });
              }}
              onClickDay={async (e) => {
                const res = await apiservice({
                  path: "/banner/updateview_banner",
                  method: "put",
                  body: {
                    id: day,
                    start: e,
                  },
                  token: token?.accessToken,
                });
                if (res?.status == 200) {
                  callAPI();
                  setTimeout(() => {
                    setHandelCalendar((val) => !val);
                  }, 500);
                }
              }}
            />
          </Text>
        </View>
      )}
      {handelCalendar1 && (
        <View
          style={{
            width: width * 0.15,
            position: "absolute",
            zIndex: 99,
            top: 415,
            left: 400,
          }}
        >
          <Text
            style={{
              fontSize: 10,
              color: "#000",
              textAlign: "center",
              fontFamily: "Prompt-Regular",
            }}
          >
            <Calendar
              value={dateState1}
              onChange={changeDate1}
              onChangeText={(text) => {
                setbody({ ...body, expireDate: text });
              }}
              onClickDay={async (a) => {
                const res = await apiservice({
                  path: "/banner/updateview_banner",
                  method: "put",
                  body: {
                    id: day,
                    exp: a,
                  },
                  token: token?.accessToken,
                });
                if (res?.status == 200) {
                  callAPI();
                  setTimeout(() => {
                    setHandelCalendar1((val) => !val);
                  }, 500);
                }
              }}
            />
          </Text>
        </View>
      )}
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: width * 0.85,
    height: height,
    paddingHorizontal: width * 0.01,
  },
  viewfree: {
    justifyContent: "space-between",
    width: width * 0.83,
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  textfree1: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    alignSelf: "center",
  },
  viewbanner: {
    width: width * 0.5,
    height: height * 0.35,
    backgroundColor: "#fff",
    padding: 20,
    flexDirection: "row",
  },
  img: {
    width: width * 0.24,
    height: 150,
  },
  imgfix: {
    width: width * 0.2,
    height: 100,
    borderWidth: 0.5,
    borderColor: "#44444450",
  },
  imgfixflat: {
    width: 85,
    height: 50,
    marginRight: 5,
    marginBottom: 5,
  },
  texthead: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    marginTop: 10,
  },
  texthead1: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
  },
  textfic: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#ABABAB",
    marginTop: 10,
  },
  textshow: {
    fontFamily: "Prompt-Regular",
    fontSize: 14,
    color: "#000",
    marginTop: 10,
  },
  textto: {
    fontFamily: "Prompt-Regular",
    fontSize: 14,
    color: "#000",
    marginHorizontal: 20,
    alignSelf: "center",
  },
  touch: {
    width: width * 0.1,
    height: 30,
    borderWidth: 0.5,
    borderColor: "#8898AA",
    borderRadius: 5,
    paddingLeft: 20,
  },
  botton1: {
    alignSelf: "flex-end",
    padding: 5,
    marginLeft: -30,
  },
  shod: {
    width: 35,
    height: 35,
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#8898AA",
    marginRight: 20,
  },
  touchedit: {
    width: 150,
    height: 40,
    justifyContent: "center",
    backgroundColor: "#F3F3F3",
    borderRadius: 10,
    alignSelf: "flex-end",
  },
  tochup: {
    width: 120,
    height: 40,
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    justifyContent: "center",
  },
  textup: {
    fontSize: 16,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    alignSelf: "center",
  },
  textRe: {
    fontSize: 12,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    marginTop: 10,
  },
  viewtouch: {
    flexDirection: "row",
    width: width * 0.25,
    justifyContent: "space-between",
    alignSelf: "center",
    marginTop: 20,
  },
  touchadd: {
    width: 150,
    height: 40,
    justifyContent: "center",
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    borderRadius: 10,
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    alignSelf: "center",
  },
  botton2: {
    alignSelf: "center",
    marginLeft: -25,
  },
});
